import { useMemo } from 'react';

import { DocumentController } from '@/components/Shared/ui';
import { stringToCamelCase } from '@/services';
import { useAppSelector } from '@/store';

import { FILE_NAMES } from '../../constants';
import { GrnFactoryCheck } from '../../entities';
import useInstructionsText from '../../hooks/useInstructionsText';

const SapaBank: React.FC = () => {
  const { attachedFiles, selectedBank } = useAppSelector(
    (state) => state.financingStep
  );

  useInstructionsText();

  const latestGrnSapaFile = useMemo(() => {
    if (!attachedFiles || attachedFiles.length === 0) return null;
    const filteredGrnSapaFilesByOfferedUuid = attachedFiles.filter(
      (file) =>
        file.type === 'grnSapa' &&
        file.name.includes(selectedBank?.offeredUuid ?? '')
    );
    const sortedGrnSapaFiles = (
      filteredGrnSapaFilesByOfferedUuid.length > 0
        ? filteredGrnSapaFilesByOfferedUuid
        : attachedFiles.filter((file) => file.type === 'grnSapa')
    ).sort((file1, file2) => {
      const date1 = file1.create_date;
      const date2 = file2.create_date;
      return new Date(date2).getTime() - new Date(date1).getTime();
    });
    return sortedGrnSapaFiles[0];
  }, [attachedFiles, selectedBank?.offeredUuid]);

  const files = useMemo(() => {
    if (!attachedFiles) return [];
    return attachedFiles
      .map((item) => ({
        ...item,
        type: stringToCamelCase(item.type)
      }))
      .filter((value) => {
        return value.type === 'spouseConsent' || value.type === 'techPassport';
      });
  }, [attachedFiles]);

  return (
    <div className="financing-step__form">
      {files.map((file) => (
        <DocumentController
          key={file.type}
          fileLink={file.uuid}
          title={FILE_NAMES[file.type as keyof typeof FILE_NAMES]}
          downloadable
        />
      ))}
      {latestGrnSapaFile ? (
        <>
          <DocumentController
            key={latestGrnSapaFile.type}
            fileLink={latestGrnSapaFile.uuid}
            title="Гарантийное письмо"
            downloadable
          />
          <GrnFactoryCheck
            grnFileLink={latestGrnSapaFile.link}
            grnFileType={latestGrnSapaFile.type}
          />
        </>
      ) : (
        files.length === 0 && (
          <p className="financing-step__no-documents">Нет документов</p>
        )
      )}
    </div>
  );
};

export default SapaBank;
